import { GenericObjectValue } from '../interfaces';

export const isGenericObjectValue = (objectValue: any): objectValue is GenericObjectValue => {
    return objectValue != null && typeof objectValue === 'object' && 'objectType' in objectValue;
};
